import React, { RefObject, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNotification, useTranslate } from "@refinedev/core";

import { Modal, ModalRef } from "@shared/components";
import { PlanFormProduct } from "@modules/defaultProducts/components/ProductPlans/PlanFormProduct";
import { masks } from "@core/utils/masks";
import { api } from "@api/api";

type EditAgreementProductPlanModalProps = {
  modalRef: RefObject<ModalRef>;
  onComplete?: () => void;
};

export function EditAgreementProductPlanModal({ modalRef, onComplete }: EditAgreementProductPlanModalProps) {
  const translate = useTranslate();
  const { open } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const methods = useForm<any>({
    defaultValues: {
      id: undefined,
      name: "",
      description: "",
      value: "",
      level: 0,
      vindi_token: "",
      access_amount: 0,
      audiobook_quantity: 0,
      book_quantity: 0,
      magazine_quantity: 0
    },
    mode: "onBlur",
  });

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      const values = methods.getValues();
      const id = (modalRef.current?.getId?.() as any) || values.id;
      const payload = {
        name: values.name,
        description: values.description,
        value: values.value ? String(Number(masks.unmask(values.value)) / 100) : "0",
        level: values.level,
        vindi_page: values.vindi_page,
        vindi_token: values.vindi_token,
        access_amount: Number(values.access_amount),
        audiobook_quantity: Number(values.audiobook_quantity),
        book_quantity: Number(values.book_quantity),
        magazine_quantity: Number(values.magazine_quantity),
      };

      await api.patch(`v1/subscription_plan_admin/${id}/`, payload);

      open?.({
        type: "success",
        message: translate("subscription_plan_admin.success.edit"),
      });

      onComplete?.();
      modalRef.current?.close();
    } catch (error) {
      console.error('Error updating agreement product plan:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      ref={modalRef}
      title={translate("subscription_plan_admin.titles.edit")}
      onConfirm={handleConfirm}
      methods={methods}
      isPending={isLoading}
    >
      <FormProvider {...methods}>
        <PlanFormProduct productId={true} />
      </FormProvider>
    </Modal>
  );
}


